import React, { Component } from "react";
import FormInput from "./FormInput/FormInput";

class Home extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="contactContainer">
        <div className="contactContainer__left">
          <h3>Store Information</h3>
          <div className="contactContainer__left__item">
            <i className="fas fa-envelope" />
            <p>
              Mailing Adress: <br /> Med Source International 803 W. Big Beaver
              Rd. <br /> Suite 355 Troy, MI 48084
            </p>
          </div>
          <div className="contactContainer__left__item">
            <i className="fas fa-clock" />
            <p>
              Call Center Hours: <br /> Monday to Friday: 5:00am to Midnight CST{" "}
              <br />
              Saturday and Sunday: 5:00am to 8:00pm CST
            </p>
          </div>
          <div className="contactContainer__left__item">
            <i className="fas fa-phone" />
            <p>
              Toll-Free phone 1-877-768-7230 <br />
              Fax 1-586-630-3029
            </p>
          </div>
          <div className="contactContainer__left__item">
            <i className="fas fa-at" />
            <p>
              General Inquiries: <br />
              info@medsourceinternational.com
            </p>
          </div>
        </div>
        <div className="clearfix" />
        <div className="contactContainer__right">
          <h3>Contact</h3>
          <div className="contactContainer__right__form">
            <div className="">
              <form
                action="./message.php"
                method="post"
                className="contact__form"
              >
                <div className="row">
                  <FormInput
                    type="text"
                    id="name"
                    placeholder="Name"
                    required="true"
                    name="name"
                  />
                </div>
                <div className="row">
                  <FormInput
                    type="email"
                    id="email"
                    placeholder="Email"
                    required="true"
                    name="email"
                  />
                </div>
                <div className="row">
                  <FormInput
                    type="tel"
                    id="number"
                    placeholder="Number"
                    required="false"
                    name="number"
                  />
                </div>
                <div className="row">
                  <div className="contact__form--textarea">
                    <textarea
                      name=""
                      id=""
                      cols="30"
                      rows="10"
                      placeholder="Your Message"
                      required
                      name="message"
                    />
                  </div>
                </div>
                <div className="row">
                  <button type="submit" className="contact__form--button">
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="clearfix" />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js